import { createContext, use, useContext, useEffect, useReducer } from 'react';
import ajaxIncome from '../util/remote/ajaxIncome';
import ajaxExpenses from '../util/remote/ajaxExpenses';
import ajaxAsset from '../util/remote/ajaxAsset';
import ajaxLiability from '../util/remote/ajaxLiability';
import ajaxPeriod from '../util/remote/ajaxPeriod';

const initialState = { 
    incomeBalance: 0,
    expenseBalance: 0,
    assetBalance: 0,
    liabilityBalance: 0,
    assetBalanceList: null,
    currentPeriod: null,
    cashBankBalance: null,
    cashBankListing: null,
    openingBalances: null,
    openingWorth: null,
    metaData: null,
    currentPage: 1,
    mounted: false,
};

const reducer = (state, action) => {

  switch (action.type) {
    case 'CLEAR':
      return { initialState};  // Reset state completely
    default:
      return {...state, [action.type]: action.payload};
  }

};


const BalanceContext = createContext();

export const BalanceProvider = ({children}) =>{
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(()=>{
    if(state.mounted){
      getTransactions();
    }
  }, [state.currentPage]);

 
  const getIncomeBalance=async()=>{
    const server_response = await ajaxIncome.getIncomeBalance();
    if(server_response.status==="OK")
    {
        dispatch({ type: 'incomeBalance', payload: server_response.details });
    }
  }   

  const getExpenseBalance=async()=>{
        const server_response = await ajaxExpenses.getExpenseBalance();
        if(server_response.status==="OK")
        {
            dispatch({ type: 'expenseBalance', payload: server_response.details });
        }
    }   


    const getAssetBalance=async()=>{
        const server_response = await ajaxAsset.getAssetBalance();
        if(server_response.status==="OK")
        {
            dispatch({ type: 'assetBalance', payload: server_response.details });
        }
    }   

    const getLiabilityBalance=async()=>{
        const server_response = await ajaxLiability.getLiabilityBalance();
        if(server_response.status==="OK")
        {
            dispatch({ type: 'liabilityBalance', payload: server_response.details });
        }
    }   

    const getAssetBalanceListing=async()=>{

      const server_response = await ajaxAsset.listAssetBalances();
      if(server_response.status==="OK")
      {
         dispatch({type: 'assetBalanceList', payload: server_response.details})
      }else{
        dispatch({type: 'assetBalanceList', payload: '404'})

      }
    }

    const getCashBank=async(refresh = false)=>{

      if(state.cashBankBalance && !refresh) return;
      const server_response = await ajaxAsset.fetchBankCash();
      if(server_response.status==="OK"){
         dispatch({type: 'cashBankBalance', payload: server_response.details})
      }
    }

    const getCashBankListing=async(refresh = false)=>{

      if(state.cashBankListing && !refresh) return;
      const server_response = await ajaxAsset.fetchBankCashListing();
      if(server_response.status==="OK"){
         dispatch({type: 'cashBankListing', payload: server_response.details})
      }else{
        dispatch({type: 'cashBankListing', payload: '404'})
      }
    }

    const getTransactions = async(refresh = false)=>{
        dispatch({ type: 'mounted', payload: true });
        if(refresh){
            dispatch({ type: 'openingBalances', payload: null });
            dispatch({ type: 'metaData', payload: null });
        }
        dispatch({ type: 'openingBalances', payload: null });
        const payload = {
          page: refresh ? 1 : state.currentPage
        };
        const server_response = await ajaxPeriod.fetchOpeningBalances(payload);
        if(server_response.status==="OK"){
          dispatch({ type: 'openingBalances', payload: server_response.details.data });
          dispatch({ type: 'metaData', payload: server_response.details.meta });
        }else{
          dispatch({ type: 'openingBalances', payload: "404" });
          dispatch({ type: 'metaData', payload: "404" });
    
        }
      }
    
      const setCurrentPage = (page)=>{
        dispatch({ type: 'currentPage', payload: page });
      }

      const getOpeningWorth = async(refresh = false) =>{
          if(state.openingWorth && !refresh) return;
          dispatch({ type: 'openingWorth', payload: null });
          const server_response = await ajaxPeriod.fetchOpeningWorth();
          if(server_response.status === "OK"){
            dispatch({type: 'openingWorth', payload: server_response.details})
          }
      }

    const refresh = async() =>{

      await getIncomeBalance();
      await getExpenseBalance();
      await getAssetBalance();
      await getLiabilityBalance();
      await getAssetBalanceListing();
      await getCashBank(true);
      await getCashBankListing(true);
    }

  return(
    <BalanceContext.Provider value={{
      ...state, 
      dispatch, 
      getIncomeBalance,
      getExpenseBalance,
      getAssetBalance,
      getLiabilityBalance,
      getAssetBalanceListing,
      refresh,
      getCashBank,
      getCashBankListing,
      getTransactions,
      setCurrentPage,
      getOpeningWorth,

      }}>
      {children}
    </BalanceContext.Provider>
  )

}

export const useBalance = ()=>useContext(BalanceContext);

